module.exports = __webpack_public_path__ + "static/img/icon-down.3b9c4e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/myBrand/component/img/icon-down.svg
// module id = BuvV
// module chunks = 66